export default "__VITE_ASSET__c42753e3__"